<template>
	<div class="body-container">
		<div class="mask" v-if="isWeixinBrowser">
			<img class="withdrawal" src='../assets/withdrawal_tips.png'>
		</div>
		<div class="diamond-container">
			<p class="diamond-tips">钻石提现</p>
			<div class="tx-btn" @click="goDiamond">去提现</div>
		</div>
		<!-- 充值活动引导 -->
		<!-- <div class="h5-banner">
			<img src="../assets/banner_recharge.png" alt="">
		</div> -->
		<div class="yznc-header">
			<p class="id-p">
				<input type="number" name=""  @blur="checkUserNum" v-model="uid" value="" placeholder="请输入你的恋爱物语  ID">
				<span class="clearInput" @click="clearInput">×</span>
			</p>
			<p class="yznc-p" v-if="nickname!=''">
				<!--  -->
				<img :src="headImg" alt="">
				<span>{{ nickname }}</span>
				<!-- <span class="yznc-span" @click="checkUserNum">验证昵称</span> -->
			</p>
		</div>

		<div class="package clearfix">
			<p class="package-tit">选择充值套餐（爱豆）</p>
			<!-- <p class="package-item" :class="{hasFree:item.free_amount!=0,on:curIndex==index}" @click="checkThis(index)" v-for="(item , index) in rangeData">
				<span>{{item.amount}}</span>
				<span v-if="item.free_amount!=0">+{{item.free_amount}}</span>
				<span class="package-item-money">售:{{item.fee}}元</span>
			</p> -->
			<div class="package-item1" 
      :class="{on:curIndex==index}" 
      :key="index" 
      @click="checkThis(index)" 
      v-for="(item , index) in rangeData">
				<div class="packLeft">
					<div class="packTop">
						<img src="../assets/icon-bean.png"/>
						<span>{{item.amount}}</span>
						<span v-if="item.free_amount!=0">+{{item.free_amount}}</span>
					</div>
					<div v-if="item.prop_list" class="packBottom">
						<div v-for="(item1, ind) in item.prop_list" :key="ind">
							<img class="toushiI" :src="item1.img" />
							<span class="toushiT">{{ item1.name }}x{{ item1.validTime }}天</span>
						</div>
					</div>
				</div>
				<div class="packRight">
					<span class="packRightText">售:{{item.fee}}元</span>
				</div>
			</div>
		</div>
		<!-- <div class="mb10">
			<p class="package-tit ml4o">选择充值套餐</p>
			<p class="package-acount"><span v-if="curIndex!=-1">{{ rangeData[curIndex].fee }}</span><span v-else>0</span>元</p>
		</div> -->
		<!-- <div class="pay-type">
			<p class="package-tit">支付方式</p>
			<p @click="payCharge()"><i class="icon-zfb"></i>支付宝<span></span></p>
			<p v-if="isWexinShow" :style="isAppRedirect? 'height: 56px;':''" @click="payChargeWX()">
				<i class="icon-wechat"></i>
				微信支付
				<span></span>
				<span class="app-WXtips" v-if="isAppRedirect">如需微信支付，请点击复制网址使用浏览器打开进行充值</span>
			</p>
		</div> -->
		
		<div class="instructions">
			<p>充值说明</p>
			<p>1、爱豆可以用于恋爱物语语音APP内礼物的购买;</p>
			<p>2、充值订单问题请联系QQ客服：800176700咨询反馈</p>
		</div>
		<div class="payform" v-html='payform'></div>
		<div class="tips" :class="{on:tips!=''}" v-if="tips!=''">
			<p>{{ tips }}</p>
		</div>
		<!-- <div class="pop-tips" v-if="isShow" style="display: block;">
			<img :src="imgTip" alt="">
		</div> -->
		
	<div class="mask" v-show="showPayDialog">
		<div class="payDialog clearfix">
			<img @click="togglePayDialog(false)" class="cancel" src="../assets/icon_close.png" alt="">
			<!-- 显示用户信息 -->
			<div v-if="nickname" class="showInfo">
				<img class="avatar" :src="headImg" alt="">
				<p class="name">{{ nickname }}</p>
				<p class="id">ID:{{ uid }}</p>
				<p class="payTips">确认支付{{ rangeData[curIndex]&&rangeData[curIndex].fee? rangeData[curIndex].fee : '' }}元?</p>
				<p class="select">选择支付方式</p>
				<div
					v-for="(item, index) in payment"
					:key="index + 'payment'"
					@click="paymentIndex = index"
					class="payment"
					v-show="item.shown"
				>
					<img class="icon" :src="item.icon" alt="">
					<p class="payName">{{ item.name }}</p>
					<img class="check" :src="paymentIndex === index ? icon_pay_choose_pr : icon_pay_choose" alt="">
				</div>
				<div class="agreement">
					<img @click="agreement = !agreement" class="icon" :src="agreement ? icon_recharge1 : icon_recharge">
					<p @click="agreement = !agreement">我已阅读并同意</p>
					<a href="https://image.aishencn.com/html/venus_register_proto.html">《用户充值协议》</a>
				</div>
			</div>
			<!-- 显示输入框 -->
			<div v-else class="showInput">
				<div class="title">恋爱物语ID</div>
				<input
					class="id"
					type="number"
					@blur="checkUserNum"
					v-model="uid"
					placeholder="请输入你的恋爱物语ID"
				>
			</div>
			<div class="confirm" @click="payConfirm"><p>确认</p></div>
		</div>
	</div>		
	</div>
</template>
<script>
import store from '@/store/store'
import { Params,loading } from '@/util/util.js'
import icon_recharge from '@/assets/icon_recharge.png'
import icon_recharge1 from '@/assets/icon_recharge1.png'
import icon_recharge_pay_normal from '@/assets/icon_recharge_pay_normal.png'
import icon_recharge_weixin_normal from '@/assets/icon_recharge_weixin_normal.png'
import icon_pay_choose from '@/assets/icon_pay_choose.png'
import icon_pay_choose_pr from '@/assets/icon_pay_choose_pr.png'

import Qs from 'qs'
	export default {//
		name: 'recharge',
		data (){
			return {
				rangeData:[],
				curIndex:-1,
				agreement: false, // 同意协议
				showPayDialog: false, // 显示支付确认弹框
				paymentIndex: 0, // 支付方式下标
				// 支付方式汇总
				payment: [{
					name: '支付宝',
					funcName: 'payCharge',
					icon: icon_recharge_pay_normal,
					shown: true
				}, {
					name: '微信',
					funcName: 'payChargeWX',
					icon: icon_recharge_weixin_normal,
					shown: true
				}], 

				icon_recharge,
				icon_recharge1,
				icon_pay_choose,
				icon_pay_choose_pr,
				isChooseAgreement:false,
				isShowPayBox:false,
				nickname:"",
				headImg:"",
				uid:'',
				tips:'',
				payform:'',
				isShow:false,
				isWexinShow: true,
				isAppRedirect: false,
				imgTip:require('../assets/pop.png'),
				browser:{
					versions:function(){
							var u = navigator.userAgent, app = navigator.appVersion;
							return {
									trident: u.indexOf('Trident') > -1, //IE内核
									presto: u.indexOf('Presto') > -1, //opera内核
									webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
									gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
									mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
									ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
									android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
									androidChrome:u.match(/Chrome\/([\d.]+)/),// android chrome
									iosChrome: u.match(/CriOS\/([\d.]+)/), // ios chrome
									iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
									iPad: u.indexOf('iPad') > -1, //是否iPad
									safari: u.indexOf('Safari') > -1 && u.indexOf("Chrome") < 1, //是否safari
									weixin: u.indexOf('MicroMessenger') > -1, //是否微信
									qq: u.indexOf('QQ')>-1//是否QQ
							};
					}(),
					language:(navigator.browserLanguage || navigator.language).toLowerCase()
				},
				isWeixinBrowser:(/micromessenger/i).test(navigator.userAgent)
			}
		},
		created(){
			this.$store.commit('inWhichPage',{page:'mobilerecharge'});
			if(this.$route.query.mobilePage){
				this.isAppRedirect = true;
			}
			if(this.$route.query.uid){
				this.uid = this.$route.query.uid;
				this.checkUserNum();
			}
		},
		watch:{
			uid (val,oldval) {
				// console.log(val, oldval, this.nickname);
				if( this.uid!=oldval && oldval!=""){
					this.nickname = '';
					this.headImg = '';
				}
				// console.log(this.nickname);
				if(val.length>8){
					this.uid = val.slice(0,8);
				}
			}
		},
		methods:{
			// 检查是否在H5活动区间内
			h5ActivityStart () {
				if (+new Date() > +new Date('2021/11/18')) {
					return false
				}
				return true
			},
			goDiamond(){
				window.location.href = 'http://wxpay.aishencn.com/tixian/#/';
			},
			checkThis(idx){
				// if (!this.agreement) {
				// 	this.showTips('请勾选下方的 《用户充值协议》', this)
				// 	return
				// }

				this.curIndex = idx ;
				this.paymentIndex = 0; // 初始化支付方式
				// if(this.curIndex === 8 ||this.curIndex === 9){
				// 	this.isWexinShow = false
				// }else{
				// 	this.isWexinShow = true
				// }
				this.rangeData[this.curIndex].fee > 3000 ? 
        this.payment[1].shown = false :
        this.payment[1].shown = true
				this.togglePayDialog(true)
			},
			// 打开 / 关闭支付弹框
			togglePayDialog(flag) {
				this.showPayDialog = flag
				this.scrollFix(flag)
			},
			// toPay(){

			// },
			toAgreement(){
			},
			clearInput(){
				this.nickname = "" ;
				this.headImg = "" ;
				this.uid = '' ;
			},
			checkUserNum(e){
				const that = this;
				if (this.showPayDialog) window.scroll(0, 0)

				if(that.uid.trim()==""){
					that.showTips("请输入用户账号！！！",that);
				}else{
					var params = new Params(that,{
						uid:that.uid,
						method:'virgift.office.userinfo'
					});
					this.$axios.post(that.$store.state.urlData.url,Qs.stringify(params),{
						headers: {
	              'Content-Type':'application/x-www-form-urlencoded'
	          }
					}).then(function (res) {
						if (res.data.errCode==0) {
							that.nickname = res.data.data.nickname,
							that.headImg = res.data.data.headImg
						}else{
							that.showTips(res.data.errMsg,that);
							that.uid = '';
							that.nickname = '';
						}
					})
				}
			},
			getBeanList(){
				const that = this;
				var params = new Params(that,{
					pay_type:'office_pc',
					method:'virgift.office.bean.shop'
					// pay_type	:'jswx',
					// method:'bean.shop.list.jspay'
				});
				this.$axios.post(that.$store.state.urlData.url,Qs.stringify(params),{
					headers: {
              'Content-Type':'application/x-www-form-urlencoded'
          }
				}).then(function (res) {
					if (res.data.errCode==0) {
						that.rangeData = res.data.data;
						if (that.browser.versions.weixin){
							that.isShow = true;
						}
					}else{
						that.showTips(res.data.errMsg,that);
					}
				})
			},
			showTips(tips,that){
				that.tips = tips ;
				setTimeout(()=>{
					that.tips = "" ;
				},3000);
			},
			// 点击确认支付
			payConfirm() {
				const funcName = this.payment[this.paymentIndex].funcName
				this[funcName]()
			},
			payCharge(){
				const that = this;
				if (!this.agreement) {
					this.showTips('请勾选并同意《用户充值协议》', this)
					return;
				}
				if(that.nickname.trim()==""){
					that.showTips("请输入用户账号",that);
					return;
				}else if (that.uid.trim()=="") {
					that.showTips("请校验用户账号",that);
					return;
				}else if (that.curIndex==-1) {
					that.showTips("请选择充值套餐",that);
					return;
				}else{
					const that = this;

					let pay_type = "" ;

					if (that.browser.versions.mobile) {
						pay_type = "office_mobile";
					}else{
						pay_type = "office_pc";
					}
					var params = new Params(that,{
						pay_type	:pay_type,
						method:'virgift.office.buy.bean',
						bs_id:that.rangeData[that.curIndex].bs_id,
						uid:that.uid
					});
					this.$axios.post(that.$store.state.urlData.url,Qs.stringify(params),{
						headers: {
								'Content-Type':'application/x-www-form-urlencoded'
						}
					}).then(function (res) {
						if (res.data.errCode==0) {
							var str = res.data.data.form;
							that.payform = str;
							that.$nextTick(_=>{ document.forms[0].submit() })
						}else{
							that.showTips(res.data.errMsg,that);
						}
					})
				}
			},
			payChargeWX(){
				const that = this;
				if (!this.agreement) {
					this.showTips('请勾选并同意《用户充值协议》', this)
					return;
				}
				if(that.nickname.trim()==""){
					that.showTips("请输入用户账号",that);
					return;
				}else if (that.uid.trim()=="") {
					that.showTips("请校验用户账号",that);
					return;
				}else if (that.curIndex==-1) {
					that.showTips("请选择充值套餐",that);
					return;
				}else{
					const that = this;

					let pay_type = "" ;

					if (that.browser.versions.mobile) {
						pay_type = "office_mobile";
					}else{
						pay_type = "office_pc";
					}

					if(that.isAppRedirect){
						var input = document.createElement('input');
						var text = 'https://www.tiduhn.cn/wxh5/mobilrecharging/?uid=' + that.uid;
						input.setAttribute('readonly', 'readonly');
						input.setAttribute('value', text);
						document.body.appendChild(input);
						input.select();
						try{
							var res = document.execCommand('copy');
							document.body.removeChild(input);
							that.showTips('已复制', that);
						}catch(e){
							that.showTips('复制失败，请前往官网充值~', that);
						}
						return;
					}

					var params = new Params(that,{
						pay_type:pay_type,
						method:'h5wxpay.unifiedorder',
						bs_id:that.rangeData[that.curIndex].bs_id,
						uid:that.uid
					});
					this.$axios.post(that.$store.state.urlData.url,Qs.stringify(params),{
						headers: {
								'Content-Type':'application/x-www-form-urlencoded'
						}
					}).then(function (res) {
						if (res.data.errCode==0) {
							// var str = res.data.data.form;
							var str = res.data.data.mwebUrl;
							// var str = res.data.data.mwebUrl + '&redirect_url=http://www.tiduhn.cn/recharge';
							// that.payform = str;
							// that.$nextTick(_=>{ document.forms[0].submit() })
							window.location.href = str;

							// 正式环境充值成功地址：
							// https://www.tiduhn.cn/paysuccess?charset=utf-8&out_trade_no=OB2021091610305327&method=alipay.trade.wap.pay.return&total_amount=0.01&sign=KfxeekyDGxrnY58KabBx%2FrxeNRBejoVohpEgKvCO14eMCHsjiUKTC8gPiWrezfqcIqzmfxycx4Y7GVFCFCpLITewFzapAOdWnjfoV%2BuFNrOOtPOce3T5s8vh8zMFffg5VghIZD4EvI4IOzErEj8rdAR%2FY6IJBpe7mHyLTsMJvD98rA1t1B5kxFtQef8FXIRfCGy0XGh2lkkwnBYWWxA7U6rMzUtuL1VTfO9CAURA3DKmO5zp0FSR9iNu9xXyY9rN8goZxW5it8zoCkJKpC60qx%2FQg9UkTXxDZxtkDXz87xRN%2FrnPIAJ0VRSF9vHDZvP8fA%2BYfTEE8tN8zDOYOK9PtQ%3D%3D&trade_no=2021091622001464561439607491&auth_app_id=2018081761100402&version=1.0&app_id=2018081761100402&sign_type=RSA2&seller_id=2088121299360698&timestamp=2021-09-16%2010%3A31%3A08
						}else{
							that.showTips(res.data.errMsg,that);
						}
					})
				}
			},
			// 打开弹框时，定位当前滚动距离
			scrollFix(showPage) {
				if (showPage == true) {
					this.scrollTopNum =
						this.$store.state.scrollTopNum ||
						window.pageYOffset ||
						document.documentElement.scrollTop ||
						document.body.scrollTop;
					document.querySelector("body").setAttribute("style", "position:fixed");
					document.body.style.top = "-" + this.scrollTopNum + "px";
				} else {
					document.querySelector("body").removeAttribute("style");
					if (this.$store.state.scrollTopNum)
						this.$store.commit("setScrollTopNum", 0);
					window.scrollTo(0, this.scrollTopNum);
				}
			},
		},
		mounted(){
			this.getBeanList();

		}
	}
</script>
<style scoped>
	.body-container{
		background-color: #FFF;
	}
	.clearInput{
		position: absolute;
		right: 5%;
		color: #999999;
		font-size: 20px;
		padding: 0 15px;
	}
	.tips{
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		display: none;
		transition: all .5s;
		z-index: 9999;
	}
	.tips.on{
		display: block;
	}
	.tips p{
		display: inline-block;
		margin: 60% auto 0;
		color: #ffffff;
		background: rgba(0,0,0,.8);
		border-radius: 5px;
		padding: 15px 20px;
	}
	.id-p{
		position: relative;
		height: 34px;
		margin-top: 13px;
	}
	.id-p input{
		font-size: 16px;
		height: 30px;
		width: 92%;
		border: none;
		outline: none;
		line-height: 30px;
	}

	.diamond-container{
		position: relative;
		width: 100%;
		height: 68px;
		line-height: 68px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 8px solid #F7F7F9;
	}
	.diamond-container .diamond-tips{
		position: relative;
		padding-left: 45px;
		font-size: 16px;
		color: #5C5C5C;
	}
	.diamond-container .diamond-tips::before{
		content: "";
		display: block;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 15px;
		margin: auto;
		width: 23px;
		height: 20px;
		background: transparent url('../assets/icon_diamond.png') no-repeat;
		background-size: cover;
	}
	.diamond-container .tx-btn{
		position: absolute;
		right: 15px;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 77px;
		height: 32px;
		line-height: 32px;
		color: #FFF;
		background-image: linear-gradient(226deg, #FFBB8A 0%, #FF6792 100%);
		border-radius: 16px;
	}

	.yznc-p{
		display: inline-block;
		width: 100%;
		padding: 13px 15px;
		line-height: 32px;
	}

	.yznc-p img{
		height: 32px;
		border-radius: 32px;
		width: 32px;
		display: block;
		float: left;
		margin-right: 5px;
	}

	.yznc-p span{
		font-size: 14px;
		color: #333333;
		float: left;
	}

	.yznc-header{
		border-bottom: 12px solid #F7F7F9;
	}
	.yznc-span{
		font-size: 16px;
		color: #F54E31;
		margin-right: 4%;
	}
	.package{
		width: 92%;
		margin: 0 auto;
	}
	.package-tit{
		font-size: 14px;
		color: #999999;
		height: 44px;
		line-height: 44px;
		text-align: left;
	}

	.package-item{
		width: 32%;
		float: left;
		height: 84px;
		border: 1px solid #ff8700;
		border-radius: 5px;
		box-sizing: border-box;
		margin-right:2%;
		margin-bottom: 10px;
		background: url("../assets/icon-bean.png") no-repeat 15px 24px;
		background-size: 14px;
		line-height: 66px;
		text-align: left;
		text-indent: 2.3em;
		color: #F44E30;
	}

	.package-item.hasFree,.package-item.on.hasFree{
		line-height: 24px;
		background-position: 15px 16px;
	}


	.package-item span{
		display: block;
		line-height: 20px;
	}

	.package-item span:first-child{
		margin-top: 20px;
	}
	.package-item.hasFree span:first-child{
		margin-top: 13px;
	}
	.package-item.style{
		background: url("../assets/icon-bean.png") no-repeat 15px center;
		background-size: 18px;
	}



	.package-item:nth-child(3n+1){
		margin-right:0;
	}

	.package-item-money{
		font-size: 13px;
		color: rgba(51,51,51,0.8);
	}

	.package-item.on .package-item-money{
		color: #ffffff;
	}

	.package-item.on{
		color: #ffffff;
		background: #ff8700 url("../assets/icon-bean-white.png") no-repeat 20px 22px;
		background-size: 14px;
	}
	.package-item1{
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		border: 1px solid #F4F4F4;
		border-radius: 10px;
		/* height: 62px; */
		padding-top: 15px;
		padding-bottom: 15px;
		margin-top: 10px;
		background-size: 16px;
		text-align: left;
		color: #F34E2F;
	}
	.package-item1.on{
		border: 1.5px solid #FE8601
	}
	.package-item1:first{
		margin-top: 8px;
	}
	/* .packLeft{
		display: flex;
		align-items: center;
	} */
	.packTop img{
		width: 16px;
		height: 13px;
		margin-left: 10px;
		margin-right: 4px;
	}
	.packRight{
		text-align: right;
		margin-left: 5px;
	}
	.packRightText{
		font-size: 14px;
		color: #5C5C5C;
		text-align: right;
		padding-right: 12px;
		width: fit-content;
		white-space: nowrap;
	}
	.packBottom{
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.toushiI{
		width: 15px;
		height: 15px;
		margin-left: 10px;
		vertical-align: middle;
	}
	.toushiT{
		font-size: 10px;
		color: #999999;
	}

	.ml4o{
		margin-left: 4%;
	}

	.package-acount{
		width: 92%;
		height: 67px;
		margin: 15px auto;
		background: #F7F7F9;
		border-radius: 4px;
		text-align: left;
		text-indent: 2em;
		line-height: 67px;
		font-size: 20px;
		color: #F54E31;
	}

	.mb10{
		border-bottom: 10px solid #F7F7F9;
	}

	.pay-type{
		width: 92%;
		margin: 0 auto;
		text-align: left;
	}

	.pay-type p:not(:first-of-type){
		position: relative;
		font-size: 16px;
		color: #232323;
		height: 48px;
		line-height: 48px;
		border-top: 1px solid #E3E3E3;
	}

	.pay-type p:not(:first-of-type) span{
		font-size: 20px;
		float: right;
		color: #999999;
	}

	.icon-zfb,.icon-wechat{
		width: 24px;
		height: 100%;
		background: url('../assets/icon_recharge_pay_normal.png') no-repeat center;
		background-size: 24px;
		float: left;
		margin-right: 10px;
	}

	.icon-wechat{
		background: url('../assets/icon_recharge_weixin_normal.png') no-repeat center;
		background-size: 24px;
	}
	.instructions{
		padding: 20px 4% 30px;
		background: #F7F7F9;
		/* margin-top: 30px; */
	}
	.instructions p{
		text-align: left;
		font-size: 12px;
		color: #999999;
		line-height: 22px;
	}

	.instructions p:first-child{
		font-size: 14px;
		line-height: 26px;
	}
	.agreement {
		display: flex;
		align-items: center;
		margin-top: 13px;
	}
	.agreement .icon {
		border: 1px solid #E3E3E3;
		border-radius: 11px;
		width: 18px;
	}
	.agreement p {
		font-size: 12px;
		color: #232323;
		letter-spacing: 0;
		line-height: 20px;
		font-weight: 500;
		margin: 0 6px;
	}
	.pop-tips {
    display: none;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
		background:rgba(0,0,0,0.8);
}
.pop-tips img{
	width: 18rem;
    position: absolute;
    top: 10px;
    right: 10px;
}

	@media (max-width: 320px){
		.package-item{
			font-size: 14px;
			text-indent: 1.6em;
			background-position: 5px 22px;
		}

		.package-item.on{
			background-position: 5px 22px;
		}

		.package-item.hasFree{
			background-position: 5px 16px;
		}
		.package-item.on.hasFree{
			background-position: 5px 16px;
		}
	}
	
	.payDialog {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 288px;
		background: #FFFFFF;
		border-radius: 14px;
		padding: 20px;
	}
	.mask>.payDialog>.cancel {
		width: 18px;
		margin: 0;
		float: right;
	}
	.mask>.payDialog>.confirm {
		width: 248px;
		height: 40px;
		margin: 30px auto 0;
		background: #F54F31;
		border-radius: 21px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		color: #FFFFFF;
		font-weight: 500;
	}
	.mask>.payDialog>.showInfo {
		margin-top: 20px;
		font-size: 16px;
	}
	.mask>.payDialog>.showInfo>.avatar {
		position: absolute;
		width: 81px;
		height: 81px;
		border: 3px solid #FFFFFF;
		background-color: #fff;
		border-radius: 50%;
		left: 50%;
		top: -45px;
		transform: translateX(-50%);
	}
	.mask>.payDialog>.showInfo>.name {
		margin-top: 30px;
		color: #222222;
		letter-spacing: 0;
		font-weight: 600;
	}
	.mask>.payDialog>.showInfo>.id {
		margin-top: 10px;
		font-family: PingFang-SC-Bold;
		font-size: 12px;
		color: #666660;
		font-weight: 500;
	}
	.mask>.payDialog>.showInfo>.payTips {
		margin: 25px 0;
		font-size: 19px;
		color: #232323;
		font-weight: 550;
	}
	.mask>.payDialog>.showInfo>.select {
		text-align: left;
		font-size: 12px;
		color: #999999;
		font-weight: 500;
	}
	.mask>.payDialog>.showInfo>.payment {
		margin: 20px 0;
		display: flex;
	}
	.mask>.payDialog>.showInfo>.payment>.icon {
		width: 21px;
		height: 21px;
		margin-right: 15px;
	}
	.mask>.payDialog>.showInfo>.payment>.payName {
		font-size: 14px;
		flex-grow: 1;
		color: #232323;
		font-weight: 550;
		text-align: left;
	}
	.mask>.payDialog>.showInfo>.payment>.check {
		width: 20px;
		height: 20px;
	}
	.mask>.payDialog>.showInput {
		margin-top: 20px;
	}
	.mask>.payDialog>.showInput>.title {
		font-size: 18px;
		color: #232323;
		font-weight: 500;
	}
	.mask>.payDialog>.showInput>.id {
		margin-top: 30px;
		background: #F7F7F9;
		border-radius: 22px;
		border: 0 solid;
		width: 248px;
		height: 42px;
		font-size: 16px;
		color: #232323;
		font-weight: 800;
		text-align: center;
	}
	.mask>.payDialog>.showInput>.id::placeholder {
		color: rgba(153, 153, 153, 1);
		font-weight: normal;
		text-align: center;
	}
.mask{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
}
.mask .withdrawal{
  width: 100%;
  margin-top: 20px;
}
.pay-type p span.app-WXtips{
	font-size: 12px;
	line-height: 0;
	text-align: left;
	position: absolute;
	left: 35px;
	bottom: 12px;
}

.h5-banner {
	margin: 0 auto;
	width: 100%;
	height: 20vw;
	background-color: #F7F7F9;
	border-bottom: 10px solid #F7F7F9;
}
.h5-banner>img {
	width: 92vw;
	height: 20vw;
	border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/mobilPage/rechargePage.vue